import React, { FC, useContext } from "react";
import { Collapse } from "@material-ui/core";
import { VisibilityContext } from "../../context";
import { FILTERS } from "../../constants";
import Autocomplete from "../Search/Autocomplete";

type AutocompletesProps = {
  visibilitySection: string;
  tooltips?: Record<string, Record<string, string>>;
};

const Autocompletes: FC<AutocompletesProps> = ({ visibilitySection, tooltips = {} }) => {
  const [visibilityContext] = useContext(VisibilityContext);

  return (
    <Collapse in={visibilityContext[visibilitySection]}>
      {Object.keys(FILTERS.MENU_AUTOCOMPLETES_TITLES).map((title) => (
        <Autocomplete key={title} objectKey={title} tooltips={tooltips[title]} />
      ))}
    </Collapse>
  );
};

export default Autocompletes;
